import { ToggleButtonGroup as Bs5ToggleButtonGroup } from 'react-bootstrap5';

export default Bs5ToggleButtonGroup;
